import TopNav from "../../home/components/TopNav";

export default function EnterpriseIntelligencePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-violet-50" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />
      <div className="pt-14 flex items-center justify-center" style={{ height: 'calc(100vh - 3.5rem)' }}>
        <div className="text-center">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-violet-100 to-violet-200 rounded-2xl flex items-center justify-center">
            <i className="ri-spy-line text-4xl text-violet-600"></i>
          </div>
          <h1 className="text-2xl font-bold text-slate-800 mb-3">企业情报</h1>
          <p className="text-slate-500 text-base mb-8">产品功能开发中，敬请期待...</p>
          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm">
            <span className="w-2 h-2 bg-violet-400 rounded-full animate-pulse"></span>
            <span>即将上线</span>
          </div>
        </div>
      </div>
    </div>
  );
}
